( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( window ).width() > 1024 ) {
        // Close panel and return focus when keyboard focus leaves the nav
        $( '.navigation-one .primary-navigation__panels' ).on( 'focusout', function( e ) {
          const $menuItem = $( this );
          const newFocus = e.relatedTarget;
          if ( newFocus === null ) return;
          if ( !$menuItem.has( newFocus ).length ) {
            const $trigger = $menuItem.find( '.primary-menu-item__link.is-open' );
            if ( $trigger.length ) {
              $trigger.trigger( 'click' );
              newFocus.focus();
            }
          }
        } );
      }

      // Sync aria-hidden on each nav panel when it opens or closes
      $( '.primary-menu-item__menu' ).each( function() {
        const panel = this;
        new MutationObserver( function() {
          const isOpen = $( panel ).hasClass( 'is-open' );
          $( panel ).attr( 'aria-hidden', isOpen ? 'false' : 'true' );
        } ).observe( panel, {attributes: true, attributeFilter: ['class']} );
      } );

      // Sync aria-expanded on mobile toggle and manage focus when mobile menu opens/closes
      const $mobileToggle = $( '.navbar-toggle-wrapper' );
      const $primaryNav = $( '#primary-nav' );

      if ( $mobileToggle.length && $primaryNav.length ) {
        let prevOpen = false;

        new MutationObserver( function() {
          const isOpen = $primaryNav.hasClass( 'is-open' );
          $mobileToggle.attr( 'aria-expanded', isOpen ? 'true' : 'false' );

          if ( isOpen && !prevOpen ) {
            $primaryNav.find( 'a, button' ).first().focus();
          } else if ( !isOpen && prevOpen ) {
            $mobileToggle.focus();
          }

          prevOpen = isOpen;
        } ).observe( $primaryNav[0], {attributes: true, attributeFilter: ['class']} );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'navigation-one', COMPONENT );
} )( app );
